import { gql } from "@apollo/client";

const GET_LG_EMAIL_TEMPLATES = gql`
  query getLgEmailTemplates {
    lgEmailTemplatesCollection {
      items {
        id
        title
        content
        templateType
      }
    }
  }
`;

export default GET_LG_EMAIL_TEMPLATES;
